"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogType = exports.LogLevel = void 0;
// 日志等级
var LogLevel = {
  Error: 'error',
  Warn: 'warn',
  Info: 'info',
  Log: 'log',
  Debug: 'debug'
}; // 日志类型

exports.LogLevel = LogLevel;
var LogType = {
  LifeCycle: 'lifeCycle',
  SysInfo: 'sysInfo',
  FailRequest: 'failRequest',
  ApiRequest: 'apiRequest',
  RenderError: 'renderError',
  SocketEvent: 'socketEvent',
  NetEvent: 'netEvent',
  Action: 'action',
  Custom: 'custom'
};
exports.LogType = LogType;